/*
 * Get-coupon.ts
 * Description: Includes the declaration
 * of the function for getting a certain coupon
 */

// Importing Axios for HTTP request
import Axios from 'axios';
// Importing variables
import {APIURL} from '@/ts/variables';
// Importing Vuex store
import {store} from '@/config/plugins';

/**
 * Getting a list of coupon
 *
 * @return {Object} Promise - coupon data
 * @param {String} slug - id of a restaurant
 */
export function getCoupons(slug: string) {
    const jwt = localStorage.getItem('jwt');
    // Using promise to handle the async properties of JavaScript
    return new Promise((resolve, reject) => {
        // Using Axios to send the request
        Axios({
            url: APIURL + 'restaurants/' + slug + '/coupons',
            method: 'get',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            params: {
                page: store.getters.currentPage,
                order_by: store.getters.orderParam,
                sort_by: store.getters.sortParam,
            },
            data: {},
        }).then((response) => {
            store.dispatch('setResponse', response.data.data);
            store.dispatch('setLastPage', response.data.meta.last_page);
            resolve(response.data.data);
        }).catch(() => {
            reject();
        });
    });
}
